<div
  class="ai-list-ingredient-menu-product-card"
  [class.has-warning-drawer]="
    product?.drawerMsg?.isWarning || product?.productCardWarningMsg?.display
  "
>
  <ng-container *ngIf="loading; else productTemplate">
    <div class="loading-container flex align-center justify-center">
      <p class="bold-font-weight">
        {{ 'i18n.lists.aiListProductCard.findingProduct' | translate }}
      </p>
      <ion-spinner class="icon-size" name="circles"></ion-spinner>
    </div>
  </ng-container>

  <ng-template #productTemplate>
    <div
      class="drawer"
      *ngIf="product?.drawerMsg || product?.productCardWarningMsg"
    >
      <app-product-card-drawer
        [drawerMessage]="product?.drawerMsg"
        [warningMessage]="product?.productCardWarningMsg"
      >
      </app-product-card-drawer>
    </div>
    <div class="product-content flex space-between default-padding">
      <div class="radio-container flex align-center">
        <ion-icon
          [name]="selected ? 'radio-button-on' : 'radio-button-off'"
          [class.selected]="selected"
          (click)="onSelectionChange()"
        >
        </ion-icon>
      </div>
      <div class="product-image flex align-center justify-center">
        <app-product-card-image
          [imageThumbnail]="product?.imageThumbnail"
          [productNumber]="product?.productNumber"
          [clickable]="!product?.notFound"
          (productImageClickEmitter)="onProductClick()"
        ></app-product-card-image>
      </div>
      <div class="product-details">
        <app-product-card-information
          [brand]="product?.summary?.brand"
          [description]="product?.summary?.productDescTxtl"
          [productNumber]="product?.productNumber"
          [salesPackSize]="product?.summary?.salesPackSize"
          [showNote]="false"
          [notFound]="product?.notFound"
          [customerProductNumber]="product?.customerProductNumber"
          [showPowerReview]="false"
          [pricePerPortion]="product?.pricePerPortion"
          (productDescriptionClickEmitter)="onProductClick()"
          [clickable]="true"
          [isGuestUser]="false"
        >
        </app-product-card-information>
      </div>
    </div>
  </ng-template>
</div>
